import { Link } from "react-router-dom";

export const Footer = ({ onNavigate }) => (
  <footer className="border-t border-cream/10 bg-pine-950 py-16 text-cream" data-testid="footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 md:grid-cols-12">
      <div className="md:col-span-5">
        <span className="inline-flex items-center rounded-2xl bg-white px-4 py-2.5">
          <img
            src="/assets/logo-full.jpg"
            alt="SpellingBee Therapy Services — Speech & Language Therapy for Schools"
            className="h-16 w-auto"
            data-testid="footer-logo"
          />
        </span>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/60">
          RCI-registered speech & language therapy, delivered in your school.
          Serving North Bengaluru — no travel for parents, no disruption for
          you.
        </p>
        <p className="mt-6 text-sm text-cream/60">
          Schools and parents: write to{" "}
          <a href="mailto:spellingbeetherapy@gmail.com" className="text-honey underline-offset-4 hover:underline">
            spellingbeetherapy@gmail.com
          </a>
          .
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/40">Explore</p>
        <ul className="mt-5 space-y-3 text-sm">
          {[
            ["services", "Services"],
            ["who-we-help", "Who We Help"],
            ["how-it-works", "How It Works"],
            ["founder", "Founder"],
            ["faq", "FAQ"],
            ["contact", "Contact"],
          ].map(([id, label]) => (
            <li key={id}>
              <button
                data-testid={`footer-link-${id}`}
                onClick={() => onNavigate(id)}
                className="text-cream/70 transition-colors hover:text-honey"
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/40">Contact</p>
        <ul className="mt-5 space-y-3 text-sm text-cream/70">
          <li>Serving North Bengaluru</li>
          <li>spellingbeetherapy@gmail.com</li>
          <li>+91 99018 87986</li>
          <li>RCI Reg. No. A58697</li>
        </ul>
        <div className="mt-8 flex items-center gap-6">
          <Link
            to="/schools"
            data-testid="footer-schools-link"
            className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-honey/80 transition-colors hover:text-honey"
          >
            For Schools →
          </Link>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-cream/40 transition-colors hover:text-cream"
          >
            Admin →
          </Link>
        </div>
      </div>
    </div>

    <div className="mx-auto mt-14 flex max-w-7xl flex-wrap items-center justify-between gap-4 border-t border-cream/10 px-5 pt-8 sm:px-8">
      <p className="text-xs text-cream/40">© 2026 SpellingBee Therapy Services. All rights reserved.</p>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cream/30">
        Supporting communication · Building brighter futures
      </p>
    </div>
  </footer>
);
